import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=4a315760&scoped=true&"
var script = {}
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=4a315760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a315760",
  null
  
)

export default component.exports